import { observer } from "mobx-react";
import { Box, Typography } from "@mui/material";
import WhiteCardTitle from "../typographies/WhiteCardTitle";
import WhiteCardInfo from "../typographies/WhiteCardInfo";
import { useStoreContext } from "../..";
import LatestLabel from "./details/LastestLabel";
import { useEffect } from "react";
import SummaryFrame from "./details/SummaryFrame";
import SummaryContent from "./details/SummaryContent";
import NoteList from "./details/NoteList";

const MyNotesSummary = observer(() => {
  const { measurementStore } = useStoreContext();

  useEffect(() => {
    if (!measurementStore.notes) {
      measurementStore.getNotes();
    }
  }, [measurementStore.notes]);

  const dataReady = Boolean(measurementStore.notes);
  const latestNotes = measurementStore.latestNotes;

  return (
    <SummaryFrame>
      <Box className="flex-row-center-start">
        <WhiteCardTitle text="Anteckningar" />
      </Box>
      <LatestLabel />
      <SummaryContent>
        {dataReady && latestNotes.length === 0 && (
          <WhiteCardInfo text="Inga registreringar" />
        )}
        {dataReady && latestNotes.length > 0 && (
          <NoteList items={latestNotes} />
        )}
      </SummaryContent>
    </SummaryFrame>
  );
});

export default MyNotesSummary;
